import { useQuery } from "react-query";

import { InformationAfterSignup } from "doxecure-commons/doxecureTypes";
import { $totype, $UUID } from "foundation-ts/commons";
import { Resp } from "foundation-ts/tsrequest";
import { Nullable } from "foundation-ts/types";

import apiClient from "@services/apiClient";
import { CorporationID } from "./hooksConstants";

const useFetchInfosAfterSignup = (corporationId: Nullable<string>) =>  useQuery(
    [CorporationID, corporationId],
    async () => {
        const [resp, status] = await apiClient.getInfosAfterSignup($UUID(corporationId)!);
        if (status !== Resp.OK) { return null; }

        return $totype<InformationAfterSignup>(resp);
    },
    {
        enabled: Boolean(corporationId)
    }
) ;

export default useFetchInfosAfterSignup ;